import React from 'react';
import Board from '../Board/Board';
import './App.css';

/** Simple app that just shows the LightsOut game. */

function App() {
  return (
    <div className="App">
      <Board />
    </div>
  );
}

export default App;
